import React, { useEffect } from 'react';
import EventLoading from '../EventLoading';
import { Stack } from '@mantine/core';
import { EventHeading } from '../EventHeadings/EventHeading';
import { CateringEventVendorDetailsCompleted } from '../types';
import { getFullLocationAddress } from '@/pages/Dashboard.page/helpers';
import { EventDetails } from '../shared/Event.details';
import { EventSales } from '../shared/Event.sales';
import { cateringtDownloadConfig } from '../CateringUpcoming/config';
import { EventDownload } from '../shared/Event.download';
import { getRestaurantInfo } from '../helpers';
import { useCateringCompletedEvent } from './useCateringCompletedEvent';
import useTrackEvent from '../useTrackEvent';

export const CateringCompleted: React.FC<{ id: string; onCloseWithoutEvent: () => void }> = ({
  id,
  onCloseWithoutEvent,
}) => {
  const { event, loading } = useCateringCompletedEvent(id);

  useTrackEvent(event);

  useEffect(() => {
    if (!loading && !event) {
      onCloseWithoutEvent();
    }
  }, [loading, event, onCloseWithoutEvent]);

  if (loading) {
    return <EventLoading />;
  }

  if (!event) {
    return <></>;
  }
  const eventTitle = `${event.productType.toLowerCase()} Event Details ${
    event.event.name ? ` - ${event.event.name}` : ''
  }`;
  const eventDetails = {
    startTime: event.event.startTime,
    setupTime: event.event?.setupTime || event.event.startTime,
    endTime: event.event?.endTime,
    restaurant: getRestaurantInfo(
      event.vendor?.internalName,
      event.vendor?.address,
      event.event.location
    ),
    placeName: event.event.account.name,
    locationAddress: getFullLocationAddress(event.event.location),
  };

  const menuItems =
    event?.menuLineItems?.map((item) => ({
      name: item.name,
      quantity: item.quantity,
      id: item.id,
    })) ?? [];

  const eventDownloadDetails = {
    ...cateringtDownloadConfig,
    leftDownloadUrl: event.packingSlipUrl || '',
    rightDownloadUrl: event.purchaseOrderUrl || '',
  };

  return (
    <EventHeading eventStartTime={event.event.startTime} title={eventTitle}>
      <Stack gap="md">
        <EventDetails eventDetails={eventDetails} />
        <EventSales menuItems={menuItems} totalOrderedItems={event.totalMenuLineItems} />
        <EventDownload eventDownloadDetails={eventDownloadDetails} />
      </Stack>
    </EventHeading>
  );
};

